import React from "react";
import "./Projects.css";
import Netflix from "../../img/netflix.png";
import Olx from "../../img/olx.png";
import reliance from "../../img/reliance.png";
import Buyend from "../../img/buy-end.png";
import { themeContext } from "../../Context";
import { useContext } from "react";


function Projects() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div id="git">
      <div className="portfolio" id="projects" >
        <span
          data-aos="zoom-in"
          style={{ color: darkMode ? "white" : "" }}
        ></span>
        <span  className="m-0 p-0">
          Projects
        </span>

        <div className="grid-container">
          <div className="grid-item">
            <a href="https://unique-zuccutto-5c2719.netlify.app/">
              <img src={Buyend} alt="buyend" />
            </a>
            <div className="project-detail"> <h1 style={{textAlign:"center"}}>Buffer</h1>
            <p>
Buffer is a software application for the web and mobile, designed to manage accounts in social networks.</p>
             <p>Tech-stack: HTML | CSS | JavaScript</p>
            </div>
            <div className="git-btn" style={{ display: "flex", gap: "100px" }}>
              <a
                target="_blank"
                href="https://github.com/Sunilrath101/Buffer-clone"
              >
                <button>Github</button>
              </a>
              <a
                target="_blank"
                href="https://unique-zuccutto-5c2719.netlify.app/"
              >
                <button> Live  </button>
              </a>
            </div>
          </div>

          <div className="grid-item">
            <a href="https://gamy-rate-5438.vercel.app/">
              <img src={Netflix} alt="netflix" />
            </a>
            <div className="project-detail"> <h1 style={{textAlign:"center"}}>AppleTv</h1>
            <p>
Apple TV+ is an American subscription streaming service owned and operated by Apple Inc. Launched on November 1, 2019</p>
             <p>Tech-stack: React | Redux | JavaScript</p></div>
           
            <div className="git-btn" style={{ display: "flex", gap: "100px" }}>

              <a
                target="_blank"
                href="https://github.com/Vipulvatsa07/gamy-rate-5438"
              >
                <button>Github</button>
              </a>

              <a target="_blank" href="https://gamy-rate-5438.vercel.app/">
                <button>Live </button>
              </a>
            </div>
          </div>

          <div className="grid-item">
            <a href="https://ajio-app.vercel.app/">
              <img src={Olx} alt="olx" />
            </a>
            <div className="project-detail"> <h1 style={{textAlign:"center"}}>Ajio</h1>
            <p>AJIO, a fashion and lifestyle brand, is Reliance Retail's digital commerce initiative and is the ultimate fashion destination.</p>
             <p>Tech-stack: React | json-server | JavaScript</p></div>
            <div className="git-btn" style={{ display: "flex", gap: "100px" }}>
              <a
                target="_blank"
                href="https://github.com/piyushkhurana8744/-prompt-wilderness-693"
              >
                <button>Github</button>
              </a>

              <a target="_blank" href="https://ajio-app.vercel.app/">
                <button>Live </button>
              </a>
            </div>
          </div>

          <div className="grid-item"> 
            <a href="https://admirable-gnome-524e51.netlify.app/">
              <img src={reliance} alt="olx" />
            </a>
            <div className="project-detail" > <h1 style={{textAlign:"center"}}>Reliance dig.</h1>
            <p>Reliance Digital is an Indian consumer electronics retailer. It is a subsidiary of Reliance Retail,a subsidiary of Reliance Industries</p>
             <p>Tech-stack: HTML | CSS | JavaScript</p>
            </div>
            <div className="git-btn" style={{ display: "flex", gap: "100px" }}>
              <a
                target="_blank"
                href="https://github.com/Vipulvatsa07/rotten_snake"
              >
                <button>Github </button>
              </a>
              <a
                target="_blank"
                href="https://admirable-gnome-524e51.netlify.app/"
              >
                <button>Live </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
  
      </div>
    </div>
  );
}

export default Projects;
